export enum FlightSearchTrackingEventName {
  // Fired when a user switches between Round Trip and One Way
  changed_trip_type = "changed_trip_type",

  // Fired when user lands on the calendar.
  viewed_calendar = "viewed_calendar",
  // When the user selects the dates on the calendar page
  search_calendar_changed = "search_calendar_changed",

  // Fired when user lands on the flight search homepage
  viewed_air_search = "viewed_air_search",
}
